import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import styles from './SummaryStat.module.scss';
import MoreInfoTooltip from 'src/components/more-info-tooltip/MoreInfoTooltip';
import React from 'react';
import { SummaryStatViewModel } from 'src/types/view-models/budgets/summary-stat.view.model';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { trackClick } from 'src/hooks/useAdobeTags';
import { useLocation } from 'react-router-dom';
import SyncLoader from 'src/components/sync-loader/SyncLoader';
import { LoaderType } from 'src/types/loader-type.enum';
import { IconEdit } from '@americanexpress/dls-react';
import IconButton from 'src/components/icon-button/IconButton';
import { ButtonType } from 'src/types/button-type.enum';
import Selectors from 'src/utils/selectors';
import { DLSSize } from 'src/types/dls-size.enum';

export default function SummaryStat({
    title,
    tooltip,
    amount,
    isGreen,
    className,
    tooltipClassName,
    tagName,
    onClick,
    iconTitle
}: SummaryStatViewModel): JSX.Element {
    const { isMinWidthSmall } = useBreakpoints();
    const { pathname } = useLocation();
    return (
        <div className={`${styles.summaryStat} ${className}`}>
            <div className={styles.titleRow}>
                <Typography
                    variant={isMinWidthSmall ? TypographyVariants.SUBTEXT : TypographyVariants.CAPTION}
                    component="p"
                    className={styles.statsBoxHeader}
                    data-cy={Selectors.SpendSmart.SUMMARY_STAT_TITLE}
                >
                    {title}
                </Typography>
                <MoreInfoTooltip
                    body={tooltip}
                    className={`${tooltipClassName} ${styles.statsBoxTooltip}`}
                    buttonAriaLabel={title}
                    onClick={() => trackClick(pathname, tagName)}
                />
            </div>
            <div className={styles.amountRow}>
                <SyncLoader type={LoaderType.PILL}>
                    <div className={styles.amountTextOptionalIcon}>
                        <Typography
                            variant={isMinWidthSmall ? TypographyVariants.HEADING_M : TypographyVariants.HEADING_XS}
                            component="p"
                            className={`${isGreen ? styles.greenText : ''}`}
                            data-cy={Selectors.SpendSmart.SUMMARY_STAT_AMOUNT}
                        >
                            {amount}
                        </Typography>
                        {onClick && iconTitle && (
                            <IconButton
                                variant={ButtonType.SECONDARY}
                                className={styles.iconEditButton}
                                icon={<IconEdit size={isMinWidthSmall ? undefined : DLSSize.SMALL} />}
                                title={iconTitle}
                                onClick={onClick}
                            />
                        )}
                    </div>
                </SyncLoader>
            </div>
        </div>
    );
}
